// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__03ySF","title":"style_title__LDE-0","CTA":"style_CTA__DLUPe"};